import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { StripeElementsDirective, StripePaymentElementComponent, StripeService, injectStripe } from 'ngx-stripe';
import { BaseModalComponent } from 'src/app/core/base-modal.componant';
import { StripeProductData } from '../../models/stripe/stripe-product-data';
import { StripeElementsOptions, StripePaymentElementOptions } from '@stripe/stripe-js';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { RegistrationService } from 'src/app/administration/registrations/registration.service';
import { SessionService } from '../../services/session.service';
import { AlertModalComponent } from '../alert-modal/alert-modal.component';
import { Registration } from 'src/app/administration/registrations/registration';
import { GtStripeService } from '../../services/gt-stripe.service';
import { StripeTerminalReaderData } from '../../models/stripe/stripe-terminal-reader-data';
import { SignalrService } from '../../services/signalr.service';
import { environment } from 'src/environments/environment';
import { StripeCustomerData } from '../../models/stripe/stripe-customer-data';
import { PaymentType } from '../../models/payment-type-enum';
import { OutingIterationInvoiceService } from 'src/app/administration/outings/outing-iteration-invoice/outing-iteration-invoice-service';

@Component({
  selector: 'stripe-registration-payment-modal',
  templateUrl: './stripe-registration-payment-modal.component.html',
  styleUrl: './stripe-registration-payment-modal.component.scss',
  standalone: false
})
export class StripeRegistrationPaymentModalComponent extends BaseModalComponent implements OnInit {

  readonly stripe = injectStripe();
  public signalrService = inject(SignalrService);

  @ViewChild(StripeElementsDirective) elements!: StripeElementsDirective;
  @ViewChild(StripePaymentElementComponent) paymentElement!: StripePaymentElementComponent;

  public selectedReader: StripeTerminalReaderData = new StripeTerminalReaderData();
  public product: StripeProductData;
  public customerId: string;
  public paymentIntent: any;
  public registration: Registration;
  public paymentType: any = 'card';
  public creatingPaymentIntent: boolean = false;
  public readers: StripeTerminalReaderData[] = [];
  private invoice: any;
  private customer: StripeCustomerData;
  public isPaymentProcessing: boolean = false;

  public elementsOptions: StripeElementsOptions = {
    appearance: {
      theme: 'stripe'
    },
    locale: 'en',
  };

  public paymentElementsOptions: StripePaymentElementOptions = {
    layout: {
      type: 'tabs',
      defaultCollapsed: false,
    }
  };

  constructor(public dialogRef: MatDialogRef<StripeRegistrationPaymentModalComponent>,
    private dialog: MatDialog,
    private registrationService: RegistrationService,
    private outingIterationInvoiceService: OutingIterationInvoiceService,
    private stripeService: GtStripeService,
    private sessionService: SessionService,
    private ngxStripeService: StripeService) {
    super();
  }


  ngOnInit(): void {
    this.onCardPaymentConfirmation();
    this.getReaders();
  }

  getReaders() {
    this.isLoading = true;
    this.stripeService.getTerminalReaders(this.sessionService.getUser().stripeAccountId, {}).subscribe({
      next: (result: any) => {
        if (result.data.length > 0) {
          this.readers = result.data;
          this.selectedReader = result.data[0];
        }
        this.getOutingInvoice();
      },
      error: (err) => {
        this.isLoading = false;
        console.log(err);
      }
    });
  }

  getOutingInvoice() {
    this.outingIterationInvoiceService.getByIteration(this.sessionService.getGlobalOutingIteration().id).subscribe({
      next: (result) => {
        this.invoice = result;
        this.getCustomer();
      },
      error: (err) => {
        this.isLoading = false;
        console.log(err);
      }
    });
  }

  getCustomer() {
    this.stripeService.getCustomer({ query: `metadata["GolfTechId"]:"${this.sessionService.getUserId()}"` }).subscribe({
      next: (result) => {
        this.customer = result[0];
        this.isLoading = false
      },
      error: (err) => {
        console.log(err);
        this.isLoading = false
      }
    });
  }

  onPaymentSubmit() {
    if (this.paymentType === 'card') {
      this.confirmCardPayment();
    }

    if (this.paymentType === 'cash') {
      this.confirmCashPayment();
    }

    if (this.paymentType === 'online') {
      this.confirmOnlinePayment();
    }
  }

  confirmCardPayment() {
    this.isLoading = true;
    let dto = {
      accountId: this.sessionService.getUser().stripeAccountId,
      readerId: this.selectedReader.id,
      options: {
        amount: (this.sessionService.getGlobalOutingIteration().cost + this.sessionService.getGlobalOutingIteration().creditCardFee) * 100,
        currency: 'usd',
        metadata: {
          RegistrationId: this.registration.id,
          PlayerRegistrationCode: this.registration.playerRegistrationCode,
          Auth0Id: this.sessionService.getUser().auth0Id,
          UserId: this.sessionService.getUser().id
        }
      }
    };
    this.registrationService.processCardPayment(dto).subscribe({
      next: (result: any) => { 
        this.isPaymentProcessing = false;
        if (result.status === 'succeeded') {
          this.updateRegistration(PaymentType.Card);
          this.dialogRef.close('cancel');
        } else {
          this.openAlertDialog('Payment Unsuccess', result.paymentIntent.status.toString(), 'Close')
        }
      },
      error: (err) => {
        this.isLoading = false
        console.log(err);
      }
    });
  }

  confirmCashPayment() {
    this.isLoading = true;
    if (this.invoice === null) {
      let data = {
        outingIterationId: this.sessionService.getGlobalOutingIteration().id,
        cashGolfers: 1,
        createdBy: this.sessionService.getUserId()
      };
      this.outingIterationInvoiceService.create(data).subscribe({
        next: (result) => {
          this.invoice = result;
          this.updateRegistration(PaymentType.CashCheck);
        },
        error: (err) => {
          this.isLoading = false;
          console.log(err);
        }
      });
    } else {
      let data = {
        cashGolfers: this.invoice.cashGolfers + 1,
        outingIterationId: this.sessionService.getGlobalOutingIteration().id,
        lastEditedBy: this.sessionService.getUserId()
      };
      this.outingIterationInvoiceService.update(this.invoice.id, data).subscribe({
        next: (result) => {
          this.invoice = result;
          this.updateRegistration(PaymentType.CashCheck);
        },
        error: (err) => {
          this.isLoading = false;
          console.log(err);
        }
      });
    }
  }

  confirmOnlinePayment() {
    this.isLoading = true;
    this.stripe.confirmPayment({
      elements: this.paymentElement.elements,
      redirect: 'if_required'
    }).subscribe(result => {
      this.isLoading = false;
      if (result.error) {
        this.openAlertDialog('Payment Error', `There was an error processing your payment. Please try again.`, 'Close');
      } else {
        if (result.paymentIntent.status === 'succeeded') {
          this.updateRegistration(PaymentType.Card);
          this.dialogRef.close('cancel');
        } else {
          this.openAlertDialog('Payment Unsuccess', result.paymentIntent.status.toString(), 'Close')
        }
      }
    }, err => {
      this.openAlertDialog('Payment Error', `There was an error processing your payment. Please try again. \n ${err}`, 'Close')
      console.log(err);
    });
  }


  updateRegistration(paymentType: PaymentType) {
    this.registration.hasPaid = true;
    this.registration.paymentType = paymentType;
    if (paymentType === PaymentType.Card) {
      this.registration.isCheckedIn = true;
    }
    this.registrationService.update(this.registration.id, this.registration).subscribe(() => {
      this.isLoading = false;
      this.dialogRef.close();
    }, err => {
      this.isLoading = false;
      console.log(err);
    });
  }

  createPaymentIntent() {
    this.isLoading = true;
    this.registrationService.createPaymentIntent({
      accountId: this.sessionService.getUser().stripeAccountId,
      options: {
        amount: (this.sessionService.getGlobalOutingIteration().cost + this.sessionService.getGlobalOutingIteration().creditCardFee) * 100,
        currency: 'usd',
        metadata: {
          RegistrationId: this.registration.id,
          PlayerRegistrationCode: this.registration.playerRegistrationCode,
          Auth0Id: this.sessionService.getUser().auth0Id,
          UserId: this.sessionService.getUser().id
        },
        application_fee_amount: (this.sessionService.getGlobalOutingIteration().cost * environment.stripe.applicationFee) * 100
      }
    }).subscribe({
      next: (result: any) => {
        this.ngxStripeService.changeKey(environment.stripe.token, {
          stripeAccount: this.sessionService.getUser().stripeAccountId
        });
        this.paymentIntent = result;
        this.elementsOptions.clientSecret = result.client_secret.toString();
        this.isLoading = false;
      },
      error: (err) => {
        this.isLoading = false;
        console.log(err);
      }
    })
  }

  onCardPaymentConfirmation() {
    this.signalrService.getListnerConnection(environment.signalR.registrationPaymentListener).subscribe(result => {
      this.isLoading = false;
      this.isPaymentProcessing = false;
      this.dialogRef.close(result);
    });
  }

  onCardPaymentFailure() {
    this.signalrService.getListnerConnection(environment.signalR.registrationPaymentListener).subscribe(result => {
      this.isLoading = false;
      this.isPaymentProcessing = false;
      this.openAlertDialog('Payment Error', `There was an error processing your payment. Please try again. \n ${result}`, 'Close')
    });
  }

  cancelPaymentIntent() {
    if (this.paymentIntent) {
      let dto = {
        connectedAccontId: this.sessionService.getUser().stripeAccountId,
        paymentIntentId: this.paymentIntent.id,
        cancellationReason: 'abandoned'
      }
      this.registrationService.cancelPaymentIntent(dto).subscribe({
        next: () => this.dialogRef.close('cancel'),
        error: (err) => console.log(err)
      });
    }
  }

  openAlertDialog(title, body, submitText) {
    const alertDialog = this.dialog.open(AlertModalComponent);
    alertDialog.componentInstance.title = title;
    alertDialog.componentInstance.body = body;
    alertDialog.componentInstance.submitText = submitText;
  }

}
